import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement("path", { d: "M10.024 2a1.606 1.606 0 011.2.543l6.559 7.46a.962.962 0 01-.788 1.57.96.96 0 01-.653-.301L11.276 5.512a.167.167 0 00-.292.11v11.42a.962.962 0 01-1.638.68.962.962 0 01-.281-.68V5.622a.167.167 0 00-.292-.11L3.806 10.28a.96.96 0 01-1.44-1.268l6.558-7.462A1.608 1.608 0 0110.024 2z" })
);
export {
  t as default
};
